import queryClient from "single-spa/react-app/query-client";

import LeadGeneratorThreadPrefetchService from "./threadPrefetchService";

const leadGeneratorThreadPrefetchService = LeadGeneratorThreadPrefetchService.initialize({
    queryClient,
});

export default leadGeneratorThreadPrefetchService;
